/** Round a canonical ISO month down to its calendar-quarter start. */
export function quarterStartMonth(month: string): string {
  const [year, number] = month.split("-").map(Number);
  const start = Math.floor((number - 1) / 3) * 3 + 1;
  return `${year}-${String(start).padStart(2, "0")}`;
}

/** Preserve the 24-month initial window, extending only quarterly starts. */
export function defaultDateFrom(
  period: "monthly" | "quarterly",
  now = new Date(),
): string {
  // Use day 1 so dates such as October 31 cannot overflow into December.
  const from = new Date(now.getFullYear(), now.getMonth() - 23, 1);
  const month = `${from.getFullYear()}-${String(from.getMonth() + 1).padStart(2, "0")}`;
  return period === "quarterly" ? quarterStartMonth(month) : month;
}

/** Default ranges selected by the granularity toggle (monthly stays 12 months). */
export function defaultFilterRange(
  months: readonly string[],
  period: "monthly" | "quarterly",
): { from: string | null; to: string | null } {
  const window = months.slice(period === "monthly" ? -12 : -24);
  let from = window[0] ?? null;
  const to = window[window.length - 1] ?? null;
  if (from && period === "quarterly") {
    const start = quarterStartMonth(from);
    // Do not let the filter's available-history clamp restore a partial start.
    // If there is no complete start in the available history, retain the
    // original range; the existing coverage guard keeps comparisons absent.
    from = start >= months[0]
      ? start
      : months.find((month) => month === quarterStartMonth(month)) ?? from;
  }
  return { from, to };
}